module.exports = __webpack_public_path__ + "static/media/ISFP-FI.720ae11d.svg";